/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsOutsideHorizontally: {
  name: 'chevrons-outside-horizontally';
  data: string;
} = {
  name: 'chevrons-outside-horizontally',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.354 4.354a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L1.707 8l3.647-3.646Zm6-.708a.5.5 0 0 0-.708.708L14.293 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4Z" fill="currentColor"/></svg>`,
};
